const platforms = {
  facebook: 'https://www.facebook.com/sharer/sharer.php?u=',
	twitter: 'https://twitter.com/intent/tweet?url=',
	line: 'https://social-plugins.line.me/lineit/share?url=',
}

const windowFeatures = (function() {
	let w = Math.min(640, screen.width - 32),
			h = Math.min(480, screen.height - 32),
			l = (screen.width - w) / 2,
			t = (screen.height - h) / 2
	return `width=${w},height=${h},left=${l},top=${t}`
})()

export default class ShareButton {

	constructor(node) {
		if (!node || !platforms[node.dataset.platform]) return
		this.url = platforms[node.dataset.platform]
		this.href = node.href ? encodeURI(node.href) : location.href
		node.onclick = this.share.bind(this)
	}

	share(e) {
		e.preventDefault()
		window.open(this.url + this.href, '_blank', windowFeatures)
	}
}
